export default {
  defaultKpiName: 'Sales',
  modelReport: 'Model Overview',
  kpi: 'KPI',
  customKpiOption: 'Custom…',
  customKpiSelector: 'KPIs to add up',
  customKpiMinHint: 'Choose at least two KPIs to add them up',
  customKpiApproximate: 'Custom selection: the report adds up the chosen KPIs as the Total does. The model quality metrics, the saturation curves\' optimal zones and the average ROAS by period are approximate.',
  manageAccess: 'Manage Access',
  shareModelReport: 'Share Model Report',
  aboutOptimalZones: 'About Optimal Zones',
  zone1: 'Zone 1',
  zone1Desc: 'This range should generally be avoided, as it falls below a Minimum Spending Threshold, resulting in negligible contributions. Any dollars spent in this zone are essentially wasted.',
  zone2: 'Zone 2',
  zone2Desc: 'In this range, dollars spent begin to show a small but rapidly growing marginal contribution. Typically, small increases in spending yield high gains in marginal contribution, until the point where Maximum Marginal Contribution is reached.',
  zone3: 'Zone 3',
  zone3Desc: 'This range, along with the next, is generally considered "optimal". As spending increases in this range, the marginal contribution of each additional dollar spent gradually diminishes, although the Return On Ad Spend (ROAS) for each dollar continues to grow.',
  zone4: 'Zone 4',
  zone4Desc: 'This range, along with the previous one, is generally considered "optimal". However, unlike in Zone 3, as spending increases in this range, ROAS gradually decreases, making further spending increasingly less efficient.',
  zone5: 'Zone 5',
  zone5Desc: 'Similar to Zone 1, this range generally should be avoided, as it represents spending beyond what is efficient. In this zone, the contribution of each additional dollar is so small that it\'s essentially a waste of resources.',
  ok: 'Ok',
  averageCpi: 'Average CPI',
  enterCpiInstructions: 'Enter average Cost Per Impression (MXN) for each media channel:',
  cancel: 'Cancel',
  save: 'Save',
  enableSharing: 'Enable sharing for this model report',
  shareLink: 'Share Link',
  close: 'Close',
  linkCopied: 'Link copied to clipboard!',
  buildingModelReport: 'Building Model Report...',
  loadingModelReport: 'Loading Model Report...',
  spend: 'Spend',
  monthly: 'Monthly',
  weekly: 'Weekly',
  totalMediaSpendInfo: 'Total media spend during the period of the report.',
  totalSalesInfo: 'Total {kpi} reported during the period of the report.',
  roasTotal: 'Total ROAS',
  roasTotalInfo: 'Total Return On Ad Spend for the report period, computed as (Instant Marketing + Carry-over Marketing) / Spend, where Instant Marketing and Carry-over Marketing come from the Sales Decomposition. When {kpi} and spend use different units, the ratio carries both of them, e.g. "units/USD". Shown as "N/A" only when the report has no spend or no marketing contribution.',
  roasCrossUnitWarning: 'This figure is the marketing contribution of the period divided by the spend of the period, and the two are measured in different units. It is not "how many times the money came back": it reads as {unit}, the {kpi} that each unit of spend brought in. Compare it against other periods or plans of the same model, not against the ROAS of a model whose {kpi} and spend share a unit.',
  roiCrossUnitWarning: 'Each channel\'s ROAS is its Attributed {kpi} bar divided by its Spend bar, and here the two are measured in different units — which is why the chart has two x-axes. The result is not "how many times the money came back": it reads as {unit}, the {kpi} that each unit of spend brought in. Use it to compare channels against each other, not against the ROAS of a model whose {kpi} and spend share a unit.',
  roiNonAdditiveWarning: '{kpi} is not additive, so the Attributed {kpi} bars are the period average while the Spend bars are the period total. Each channel\'s ROAS divides one by the other, comparing an average against a total: it still ranks the channels from best to worst, but its magnitude is neither a single period\'s return nor the whole period\'s.',
  notApplicable: 'N/A',
  fullPeriod: 'Full Period',
  monthlyDetail: 'Monthly Detail',
  weeklyDetail: 'Weekly Detail',
  segmentsDetail: 'Segments Detail',
  summary: 'Summary',
  driversPerformance: 'Drivers Performance',
  admin: 'Admin',
  modelFit: 'Model Fit',
  modelFitInfo: 'Comparison of the actual KPI being modeled vs. the model\'s predicted values. It is expected that the predicted curve follows closely the actual values being modeled.',
  confidence: 'Confidence',
  outliers: 'Outliers',
  epochs: 'Epochs',
  mape: 'MAPE (%)',
  mapeInfo: 'MAPE stands for "Mean Absolute Percentage Error", and it\'s a measure of how accurate the model is. A low MAPE value indicates a small difference, in average, between the actual KPI vs. the model\'s predicted values.',
  rae: 'RAE (%)',
  raeInfo: 'RAE stands for "Relative Absolute Error", and it\'s a measure of how accurate the model is.',
  correlation: 'Correlation (%)',
  correlationInfo: 'Measure of how correlated is the Marketing Incremental with the KPI.',
  salesDecompositionInfo: 'Decomposition of the KPI among the different components of the model.',
  mediaAttributedSalesDecomposition: 'Media Attributed {kpi} Decomposition',
  mediaAttributedSalesDecompositionInfo: 'Detailed decomposition of the Media Component into its individual vehicles.',
  mediaSpendAndReturn: 'Media Spend and Return',
  mediaSpendAndReturnInfo: 'Side-by-side comparison of media spend and the {kpi} attributed to that spend, per channel, with the resulting ROAS (attributed {kpi} / spend) for each channel. When spend and {kpi} use different units, a secondary x-axis is added and the ROAS carries both units.',
  attributedSales: 'Attributed {kpi}',
  roi: 'ROAS',
  sortBy: 'Sort by',
  toggleSeriesVisibility: 'Toggle series visibility',
  saturationCurves: 'Saturation Curves',
  generalView: 'General View',
  optimalZones: 'Optimal Zones',
  marginalRoas: 'Marginal ROAS',
  aboutMarginalRoas: 'About Marginal ROAS',
  marginalRoasDesc: 'The Marginal ROAS (mROAS) is the incremental return generated by each additional unit of investment — that is, the slope (derivative) of the saturation curve. Each chart overlays the saturation curve (left axis) with its marginal curve (right axis): the marginal value at a given spend level is the difference in incremental contribution divided by the difference in spend between that level and the previous one.',
  spendUnit: 'Spend Unit',
  editAverageCpi: 'Edit Average Cost Per Impression',
  showHistoricalSpend: 'Show historical spend datapoints',
  exportCurves: 'Export curves',
  decayCurves: 'Decay Curves',
  seasonalityEffects: 'Seasonality Effects',
  mediaSpend: 'Media Spend',
  inputOverTime: 'Input Over Time',
  marketingSpend: 'Marketing Spend',
  mediaMix: 'Media Mix',
  salesDecompositionByPeriod: '{kpi} Decomposition by Period',
  salesDecompositionAllVariables: 'All Variables',
  mediaAttributionByPeriod: 'Media Attribution by Period',
  pricingEffect: 'Pricing Effect',
  distributionEffect: 'Distribution Effect',
  quarterlyAverageRoas: 'Quarterly Average Total ROAS',
  quarterlyAverageRoasByMedia: 'Quarterly Average ROAS by Media',
  averageRoasByMedia: 'Average ROAS by Media',
  averageRoasByPeriod: 'Average ROAS by Period',
  granularity: 'Granularity',
  quarterly: 'Quarterly',
  yearly: 'Yearly',
  estimatedSalesContribution: 'Estimated {kpi} contribution by demographic segment',
  roas: 'ROAS',
  // XLSX download
  downloadXlsx: 'Download as Excel (.xlsx)',
  downloadXlsxZip: 'Download as Excel (ZIP, one file per KPI)',
  downloadXlsxFailed: 'The report could not be downloaded. Please try again.',
  xlsxDate: 'Date',
  xlsxChannel: 'Channel',
  xlsxComponent: 'Component',
  xlsxGroup: 'Group',
  xlsxGranularity: 'Granularity',
  xlsxMetric: 'Metric',
  xlsxValue: 'Value',
  xlsxModel: 'Model',
  xlsxStartDate: 'Start date',
  xlsxEndDate: 'End date',
  xlsxAttributed: 'Attributed {kpi}',
  xlsxMarginalRoas: 'Marginal ROAS',
  xlsxDatapoints: 'Datapoints',
  xlsxLag: 'Lag',
  xlsxSegment: 'Segment',
  xlsxLabel: 'Label',
  xlsxName: 'Name',
  rawReportOutput: 'RAW Report Output',
  customization: 'Customization',
  injectChanges: 'Inject changes',
  // Names used by the Admin tab's hidden-sections list for parts that have no title of their own
  hiddenGroupHeader: 'Header',
  hiddenGroupTabs: 'Tabs',
  kpiSelector: 'KPI selector',
  totalKpiOption: '"Total" KPI option',
  kpiOption: '"{kpi}" KPI option',
  totalRoasValue: 'Total ROAS value',
  modelQuality: 'Model quality gauges',
  modelFitGranularityToggle: 'Model Fit weekly/monthly toggle',
  salesDecompositionDrillDown: 'Decomposition drill-down selector',
  salesBySegment: 'Sales by Segment',
  microaudienceDifference: 'Microaudience Difference',
  microaudienceComposition: 'Microaudience Composition',
  // Sales Decomposition detailed explanations
  salesDecompositionIntro: 'Decomposition of the KPI among the different components of the model. While these vary from model to model, the following are the most frequent:',
  salesDecompositionBase: 'is the portion of {kpi} that cannot be attributed directly to the different marketing actions that took place during each period, rather it\'s the long-term result of past marketing activities.',
  salesDecompositionMedia: 'is the portion of {kpi} that is attributed specifically to media spending that happened during the period.',
  salesDecompositionSeasonality: 'accounts for {kpi} that are simply attributable to cyclic factors that repeat over time, as well as other one-time events that have a direct effect over {kpi}.',
  salesDecompositionNoise: 'is the small portion of {kpi} that cannot be attributed to any of the variables in the model, nor does it have a somewhat structured and predictable behavior as the base, therefore becoming noise in the model.',
  // AI Summary templates
  aiSummaryDefault: 'This report presents a comprehensive analysis of performance and media investment impact. It includes detailed breakdowns of media contribution, saturation curves showing optimal spending levels, and channel-specific decay patterns.',
  aiSummaryTemplate1: 'Based on the data from {dateFrom} to {dateTo}, this analysis shows {spend} {spendUnit} in media spend generated {sales} {salesUnit} in {kpi}. The model reveals key insights about channel performance and optimal spending levels through detailed saturation curves and attribution analysis.',
  aiSummaryTemplate2: 'This report examines the relationship between media investment and {kpi} performance over {dateFrom} - {dateTo}. With total spending of {spend} {spendUnit}, the analysis provides a comprehensive view of channel effectiveness and ROAS through decomposition analysis and response curves.',
  aiSummaryTemplate3: 'During the analyzed period ({dateFrom} to {dateTo}), media investments totaling {spend} {spendUnit} delivered {sales} {salesUnit} in {kpi}. The report details channel-specific contributions and optimization opportunities through advanced modeling techniques.',
  aiSummaryInitial: 'This report presents a comprehensive analysis of {kpi} performance and media investment impact. It includes detailed breakdowns of media contribution, saturation curves showing optimal spending levels, and channel-specific decay patterns.',
  aiSummaryInitialFull: 'This report presents a comprehensive analysis of {kpi} performance and media investment impact. It includes detailed breakdowns of media contribution, saturation curves showing optimal spending levels, and channel-specific decay patterns. The analysis spans from {dateFrom} to {dateTo}, with a total media investment of {spend} {spendUnit} generating {sales} {salesUnit} in {kpi}.'
}
